import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	resultLastModifiedContent: {
		id: 'entity-view.content.lastmodified',
		defaultMessage: 'Updated',
		description: 'The time when the content was modified last',
	},
	resultLastModifiedAttachment: {
		id: 'entity-view.attachment.lastmodified',
		defaultMessage: 'Uploaded',
		description: 'The time when the attachment was uploaded',
	},
	contentDraft: {
		id: 'entity-view.content.draft',
		defaultMessage: 'Draft',
		description: 'Draft state for content',
	},
	contentArchived: {
		id: 'entity-view.content.archived',
		defaultMessage: 'Archived',
		description: 'Archived state for content',
	},
	contentUnpublished: {
		id: 'entity-view.content.unpublishes',
		defaultMessage: 'Unpublished changes',
		description: 'Unpublished changes for content',
	},
	contentUntitled: {
		id: 'entity-view.content.untitled',
		defaultMessage: 'Untitled',
		description: 'Untitled page',
	},
	spaceArchived: {
		id: 'entity-view.content.spaceArchived',
		defaultMessage: 'archived',
		description: 'Indicate that the space is archived',
	},
	spaceStarred: {
		id: 'entity-view.content.spaceStarred',
		defaultMessage: 'starred',
		description: 'Indicate that the space is starred',
	},
	contentScheduled: {
		id: 'entity-view.content.scheduled',
		defaultMessage: 'Publish scheduled',
		description: 'Lozenge to indicate that the page has a scheduled publish',
	},
});
